package navigation.home.proposal.addeditproposal

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.layout.onPlaced
import androidx.compose.ui.layout.positionInParent
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.ScreenKey
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.mohamedrejeb.compose.dnd.DragAndDropContainer
import com.mohamedrejeb.compose.dnd.DragAndDropState
import com.mohamedrejeb.compose.dnd.rememberDragAndDropState
import com.essntl.components.sidepanel.SidePanel
import com.essntl.components.sidepanel.SizeConstraint
import com.essntl.components.sidepanel.Splitter
import com.essntl.components.sidepanel.rememberSidePanelState
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.ui.AddEditClientDialog
import com.essntl.features.client.ui.SelectClientDialog
import com.essntl.features.client.ui.addeditclient.AddEditClientEvent
import com.essntl.features.client.ui.allclients.AllClientsEvent
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceNavigation
import com.essntl.features.itinerary.ui.edit_itinerary_service.components.AddEditTaskPopup
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalNavigation
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalScreen
import com.essntl.features.proposal.ui.addeditproposal.components.AddEditProposalHeader
import com.essntl.features.proposal.ui.addeditproposal.components.ContactOrganizationDialog
import com.essntl.features.proposal.ui.addeditproposal.components.ProposalTabs
import com.essntl.features.proposal.ui.addeditproposal.components.SetDynamicPriceDialog
import com.essntl.features.proposal.ui.addeditproposal.components.journeyDays
import com.essntl.features.proposal.ui.selectservice.SelectServiceEvent
import com.essntl.features.proposal.ui.selectservice.SelectServiceNavigation
import com.essntl.features.proposal.ui.selectservice.SelectServiceState
import com.essntl.features.proposal.ui.selectservice.components.AddEditServicePopup
import com.essntl.features.proposal.ui.selectservice.components.ProposalServiceInfos
import com.essntl.features.proposal.ui.selectservice.components.ServiceColumn
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.features.task.ui.addedittask.AddEditTaskEvent
import essntl.key.LocalKeyEventManager
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.link.NavLinkState
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberContains
import com.essntl.uikit.rememberNumberOfDays
import com.essntl.uikit.theme.esColorScheme
import com.mohamedrejeb.calf.core.LocalPlatformContext
import com.mohamedrejeb.compose.dnd.drop.dropTarget
import core.config.FeatureConfig
import kotlinx.coroutines.flow.collectLatest
import navigation.home.address.AddressScreenModel
import navigation.home.clients.addeditclient.AddEditClientScreenModel
import navigation.home.clients.allclients.AllClientsScreenModel
import navigation.home.contact.ContactScreenModel
import navigation.home.crm.contactorganization.ContactOrganizationScreenModel
import navigation.home.customfields.CustomFieldsScreenModel
import navigation.home.edititinerary.EditItineraryScreenNav
import navigation.home.invoice.addeditinvoice.AddEditInvoiceScreenNav
import navigation.home.invoice.allinvoice.AllInvoiceScreenModel
import navigation.home.organization.OrganizationScreenModel
import navigation.home.proposal.selectservice.SelectServiceScreenModel
import navigation.home.service.addeditservice.AddEditServiceScreenModel
import navigation.home.suppliers.allsuppliers.AllSuppliersScreenModel
import navigation.home.task.addedittask.AddEditTaskScreenModel
import navigation.utils.NavLinkScreen
import navigation.utils.safePop
import org.koin.core.parameter.parametersOf
import org.koin.core.qualifier.named
import kotlin.collections.orEmpty

class AddEditProposalScreenNav(
    val proposalId: String? = null,
) : NavLinkScreen {
    private val isEdit = proposalId != null

    override val defaultTitle: String =
        if (isEdit)
            "Edit Proposal"
        else
            "Add Proposal"

    override var navLinkState: NavLinkState by mutableStateOf(
        NavLinkState(
            title = defaultTitle,
            isLoading = isEdit,
            isNavSidebarFixedByDefault = false,
            iconRes = EsIcons.Proposal,
        ),
    )

    override val key: ScreenKey = "AddEditProposalScreenNav/$proposalId"

    @Composable
    override fun Content() {
        val addEditProposalScreenModel = koinScreenModel<AddEditProposalScreenModel>(
            parameters = {
                parametersOf(
                    "proposalId" to proposalId,
                )
            },
        )

        val selectServiceScreenModel = koinScreenModel<SelectServiceScreenModel>()

        val invoiceScreenModel = koinScreenModel<AllInvoiceScreenModel>()
        val invoiceState by invoiceScreenModel.state.collectAsState()

        val addEditProposalState by addEditProposalScreenModel.state.collectAsState()
        val selectServiceState by selectServiceScreenModel.state.collectAsState()

        val addEditServiceScreenModel = koinScreenModel<AddEditServiceScreenModel>()
        val addEditServiceState by addEditServiceScreenModel.state.collectAsState()

        val allSupplierScreenModel = koinScreenModel<AllSuppliersScreenModel>()
        val allSupplierState by allSupplierScreenModel.state.collectAsState()

        var openAddServiceDialog by rememberSaveable { mutableStateOf(false) }
        var serviceToEdit by remember { mutableStateOf<ServiceModel?>(null) }
        var enableServiceEditByDefault by remember { mutableStateOf(true) }

        val allClientScreenModel = koinScreenModel<AllClientsScreenModel>()
        val allClientState by allClientScreenModel.state.collectAsState()
        var isSelectClientDialogOpen by rememberSaveable { mutableStateOf(false) }

        val addEditClientScreenModel = koinScreenModel<AddEditClientScreenModel>()
        val addEditClientState by addEditClientScreenModel.state.collectAsState()

        var openAddEditClientDialog by rememberSaveable { mutableStateOf(false) }
        var clientToEdit by remember { mutableStateOf<ClientModel?>(null) }

        var openSetPriceDialog by rememberSaveable { mutableStateOf(false) }
        var proposalService by remember { mutableStateOf<ProposalServiceModel?>(null) }

        val contactScreenModel = koinScreenModel<ContactScreenModel>()
        val contactState by contactScreenModel.state.collectAsState()

        val contactOrganizationScreenModel = koinScreenModel<ContactOrganizationScreenModel>()
        val contactOrganizationState by contactOrganizationScreenModel.state.collectAsState()

        val organizationScreenModel = koinScreenModel<OrganizationScreenModel>()
        val organizationState by organizationScreenModel.state.collectAsState()

        val organizationAddressScreenModel = koinScreenModel<AddressScreenModel>(named("organization"))
        val organizationAddressState by organizationAddressScreenModel.state.collectAsState()

        val contactAddressScreenModel = koinScreenModel<AddressScreenModel>(named("contact"))
        val contactAddressState by contactAddressScreenModel.state.collectAsState()

        val customFieldsScreenModel = koinScreenModel<CustomFieldsScreenModel>()
        val customFieldsState by customFieldsScreenModel.state.collectAsState()

        val addEditTaskScreenModel = koinScreenModel<AddEditTaskScreenModel>()
        val addEditTaskState by addEditTaskScreenModel.state.collectAsState()

        var openAddEditTravelAgentDialog by rememberSaveable { mutableStateOf(false) }

        val navigator = LocalNavigator.currentOrThrow
        val keyEventManager = LocalKeyEventManager.current

        val dragAndDropState = rememberDragAndDropState<Pair<ServiceModel, ProposalServiceModel>>()

        val sidePanelState = rememberSidePanelState(
            sidePanelVisible = false,
            panelSizeConstraint = SizeConstraint(
                minSize = 300.dp,
                maxSize = 600.dp,
            ),
        )

        var editTaskId by rememberSaveable {
            mutableStateOf<String?>(null)
        }

        var addTaskProposalId by rememberSaveable {
            mutableStateOf<String?>(null)
        }

        LaunchedEffect(navigator.lastItem) {
            addEditProposalScreenModel.onEvent(AddEditProposalEvent.GetProposal)
        }

        LaunchedEffect(sidePanelState.sidePanelOpened) {
            addEditProposalScreenModel.onEvent(AddEditProposalEvent.SelectProposalServiceDate(""))
            if (!sidePanelState.sidePanelOpened) {
                selectServiceScreenModel.onEvent(SelectServiceEvent.OpenProposalPreview(null))
            }
        }

        LaunchedEffect(keyEventManager) {
            keyEventManager.events.collectLatest {
                if (it.key == Key.H && it.type == KeyEventType.KeyUp) sidePanelState.sidePanelOpened = false
            }
        }

        /**
         * When the user selects a date by clicking the add button, open the side panel.
         */
        LaunchedEffect(addEditProposalState.selectedProposalServiceDate) {
            if (addEditProposalState.selectedProposalServiceDate.isNotEmpty()) sidePanelState.sidePanelOpened = true
        }

        /**
         * Sync the selected proposal service between the add proposal screen and the select service screen.
         */
        LaunchedEffect(addEditProposalState.selectedProposalService.value) {
            if (addEditProposalState.selectedProposalService.value != null) sidePanelState.sidePanelOpened = true

            if (addEditProposalState.selectedProposalService.value != selectServiceState.selectedProposalService.value) {
                selectServiceScreenModel.onEvent(
                    SelectServiceEvent.ProposalServiceChanged(
                        addEditProposalState.selectedProposalService.value,
                    ),
                )
            }
        }

        LaunchedEffect(selectServiceState.selectedProposalService.value) {
            if (selectServiceState.selectedProposalService.value != null) sidePanelState.sidePanelOpened = true

            if (selectServiceState.selectedProposalService.value != addEditProposalState.selectedProposalService.value) {
                addEditProposalScreenModel.onEvent(
                    AddEditProposalEvent.UpdateSelectedProposalService(
                        selectServiceState.selectedProposalService.value,
                    ),
                )
                selectServiceState.selectedProposalService.value?.let {
                    addEditProposalScreenModel.onEvent(AddEditProposalEvent.UpdateProposalService(it))
                }
            }
        }

        LaunchedEffect(addEditServiceState.addEditService.isSuccess) {
            if (addEditServiceState.addEditService.isSuccess) {
                addEditServiceState.addEditService.data?.let {
                    if (serviceToEdit != null) {
                        selectServiceScreenModel.onEvent(SelectServiceEvent.EditService(it))
                    } else {
                        selectServiceScreenModel.onEvent(SelectServiceEvent.AddService(it))
                    }
                }
                addEditServiceScreenModel.onEvent(AddEditServiceEvent.ClearService)
                openAddServiceDialog = false
                serviceToEdit = null
            }
        }

        LaunchedEffect(addEditClientState.addEditClient.isSuccess) {
            if (addEditClientState.addEditClient.isSuccess) {
                addEditClientState.addEditClient.data?.let {
                    if (clientToEdit != null) {
                        addEditProposalScreenModel.onEvent(AddEditProposalEvent.EditClient(it))
                    } else {
                        addEditProposalScreenModel.onEvent(AddEditProposalEvent.AddClient(it))
                    }
                }
                addEditClientScreenModel.onEvent(AddEditClientEvent.ClearClientState)
                openAddEditClientDialog = false
                clientToEdit = null
            }
        }

        LaunchedEffect(contactOrganizationState.addContactOrganization.isSuccess) {
            if (contactOrganizationState.addContactOrganization.isSuccess) {
                contactOrganizationState.addContactOrganization.data?.let { c ->
                    addEditProposalScreenModel.onEvent(
                        AddEditProposalEvent.UpdateProposalFields(
                            proposal = addEditProposalState.proposal.value.copy(
                                travelAgent = c.travelAgent,
                                commission = c.travelAgent?.commission,
                            ),
                        ),
                    )
                }

                contactOrganizationScreenModel.onEvent(ContactOrganizationEvent.ClearState)
                contactScreenModel.onEvent(ContactEvent.GetContacts(type = OrganizationModel.Type.TravelAgency))
                openAddEditTravelAgentDialog = false
            }
        }

        LaunchedEffect(Unit) {
            navLinkState = navLinkState.copy(
                canPop = {
                    val isProposalChanged = addEditProposalScreenModel.vm.isProposalChanged()

                    if (isProposalChanged) {
                        addEditProposalScreenModel.onEvent(
                            AddEditProposalEvent.UpdateAlertSaveProposalDialog(true),
                        )
                    }

                    !isProposalChanged
                },
            )
        }

        LaunchedEffect(addEditProposalState.getProposal) {
            val title = addEditProposalState.getProposal.data?.title

            if (isEdit) {
                navLinkState = if (title != null) {
                    navLinkState.copy(
                        title = title,
                        isLoading = false,
                    )
                } else {
                    navLinkState.copy(
                        isLoading = addEditProposalState.getProposal.isLoading,
                    )
                }
            }
        }

        LaunchedEffect(addEditProposalState.getProposal.data?.id) {
            val id = addEditProposalState.getProposal.data?.id

            if (!id.isNullOrEmpty())
                navLinkState = navLinkState.copy(
                    canRefresh = true,
                    onRefresh = {
                        addEditProposalScreenModel.onEvent(AddEditProposalEvent.GetProposal)
                        invoiceScreenModel.onEvent(InvoiceEvent.GetInvoices(id))
                    },
                )
            else
                navLinkState = navLinkState.copy(
                    canRefresh = false,
                )
        }

        LaunchedEffect(addEditTaskState.addEditTask.isSuccess) {
            if (addEditTaskState.addEditTask.isSuccess) {
                addEditTaskScreenModel.onEvent(AddEditTaskEvent.ClearTaskState)

                editTaskId = null
                addTaskProposalId = null
            }
        }

        val proposal = addEditProposalState.proposal.value

        val numberOfDays = rememberNumberOfDays(proposal.fromDate, proposal.toDate)

        val filteredProposalServices = remember(addEditProposalState) { addEditProposalState.filteredProposalServices }

        fun AddEditProposalNavigation.navigate() {
            when (this) {
                is AddEditProposalNavigation.Back -> {
                    navigator.safePop(this@AddEditProposalScreenNav)
                }

                is AddEditProposalNavigation.OpenProposalPreview -> {
                    selectServiceScreenModel.onEvent(SelectServiceEvent.OpenProposalPreview(preview))
                    sidePanelState.sidePanelOpened = true
                }

                is AddEditProposalNavigation.ClosePanel -> {
                    sidePanelState.sidePanelOpened = false
                }

                is AddEditProposalNavigation.EditService -> {
                    serviceToEdit = service
                    enableServiceEditByDefault = enableEdit
                    openAddServiceDialog = true
                }

                is AddEditProposalNavigation.AddClient -> {
                    openAddEditClientDialog = true
                }

                is AddEditProposalNavigation.SelectClient -> {
                    isSelectClientDialogOpen = true
                }

                is AddEditProposalNavigation.EditClient -> {
                    clientToEdit = client
                    openAddEditClientDialog = true
                }

                is AddEditProposalNavigation.NavigateToItinerary -> {
                    navigator.push(
                        EditItineraryScreenNav(
                            itineraryId = itineraryId,
                        ),
                    )
                }

                is AddEditProposalNavigation.Invoicing -> {
                    addEditProposalState.getProposal.data?.id?.let { id ->
                        navigator.push(
                            AddEditInvoiceScreenNav(
                                proposalId = id,
                            ),
                        )
                    }
                }

                is AddEditProposalNavigation.EditInvoicing -> {
                    navigator.push(
                        AddEditInvoiceScreenNav(
                            invoiceId = invoiceId,
                            proposalId = proposalId,
                        ),
                    )
                }

                is AddEditProposalNavigation.AddTravelAgent -> {
                    openAddEditTravelAgentDialog = true
                }

                is AddEditProposalNavigation.SetPrice -> {
                    proposalService = this.proposalService
                    openSetPriceDialog = true
                }

                is AddEditProposalNavigation.AddProposalTask -> {
                    proposalId?.let { id ->
                        addTaskProposalId = id
                        editTaskId = null

                        addEditTaskScreenModel.onEvent(
                            AddEditTaskEvent.GetProposal(
                                proposalId = id,
                            ),
                        )
                    }
                }

                is AddEditProposalNavigation.EditTask -> {
                    editTaskId = this.taskId
                    addTaskProposalId = null

                    addEditTaskScreenModel.onEvent(AddEditTaskEvent.GetTask(this.taskId))
                }
            }
        }

        val selectedAreaList = rememberContains(
            addEditProposalState.getAllArea.data.orEmpty(),
            proposal.areas.orEmpty().toSet(),
        ) { area -> area.id }

        val context = LocalPlatformContext.current

        val tabItems = remember(
            isEdit,
            FeatureConfig.hasQuickBooks,
        ) {
            if (FeatureConfig.hasQuickBooks &&
                isEdit
            )
                listOf(
                    TabState(index = 0, text = "Details"),
                    TabState(index = 1, text = "Travellers"),
                    TabState(index = 2, text = "Invoicing"),
                )
            else
                listOf(
                    TabState(index = 0, text = "Details"),
                    TabState(index = 1, text = "Travellers"),
                )
        }

        val (selectedTabIndex, setSelectedTabIndex) = remember {
            mutableStateOf(tabItems.first().index)
        }


        Column(
            modifier = Modifier
                .fillMaxSize(),
        ) {
            // AddEditProposal Header
            AddEditProposalHeader(
                state = addEditProposalState,
                onEvent = addEditProposalScreenModel::onEvent,
                invoiceState = invoiceState,
                onInvoiceEvent = invoiceScreenModel::onEvent,
                selectedAreaList = selectedAreaList,
                onSubmit = {
                    if (addEditProposalScreenModel.validation.addEditProposalForm.validate()) {
                        if (addEditProposalState.proposal.value.id.isEmpty())
                            addEditProposalScreenModel.onEvent(AddEditProposalEvent.AddProposal(context))
                        else
                            addEditProposalScreenModel.onEvent(AddEditProposalEvent.EditProposal(context))
                    }
                },
                enabled = addEditProposalScreenModel.vm.isProposalChanged(),
            )

            Spacer(modifier = Modifier.height(1.spacing))

            val scrollState = rememberScrollState()

            var sidePanelY by remember {
                mutableFloatStateOf(0f)
            }

            val sidePanelYOffset = (scrollState.value - sidePanelY).coerceAtLeast(0f)

            BoxWithConstraints(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
            ) {
                val density = LocalDensity.current

                val availableHeight = with(density) {
                    constraints.maxHeight.toDp()
                }

                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(scrollState),
                ) {
                    ProposalTabs(
                        tabItems = tabItems,
                        selectedTabIndex = selectedTabIndex,
                        setSelectedTabIndex = setSelectedTabIndex,
                    )

                    Spacer(modifier = Modifier.height(1.spacing))

                    AddEditProposalScreen(
                        state = addEditProposalState,
                        onEvent = addEditProposalScreenModel::onEvent,
                        invoiceState = invoiceState,
                        onInvoiceEvent = invoiceScreenModel::onEvent,
                        contactState = contactState,
                        contactEvent = contactScreenModel::onEvent,
                        validation = addEditProposalScreenModel.validation,
                        onNavigation = { it.navigate() },
                        selectedAreaList = selectedAreaList,
                        selectedTabIndex = selectedTabIndex,
                    )

                    Spacer(modifier = Modifier.height(3.spacing))

                    DragAndDropContainer(
                        state = dragAndDropState,
                        modifier = Modifier
                            .onPlaced { coordinates ->
                                sidePanelY = coordinates.positionInParent().y
                            },
                    ) {
                        SidePanel(
                            sidePanelState = sidePanelState,
                            isHorizontal = true,
                            sidePanel = {
                                Column(
                                    modifier = Modifier
                                        .dropTarget(
                                            key = "sidepanel",
                                            state = dragAndDropState,
                                            zIndex = 1f,
                                            dropAnimationEnabled = false,
                                        )
                                        .height(availableHeight)
                                        .padding(end = 1.5f.spacing)
                                        .graphicsLayer {
                                            translationY = sidePanelYOffset
                                        }
                                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius)),
                                ) {
                                    AddEditProposalSidePanelContent(
                                        state = selectServiceState,
                                        onEvent = selectServiceScreenModel::onEvent,
                                        allSupplierState = allSupplierState,
                                        onEventAllSupplier = allSupplierScreenModel::onEvent,
                                        isEnabled = addEditProposalState.isEnabled,
                                        onNavigation = {
                                            when (it) {
                                                is SelectServiceNavigation.AddService -> {
                                                    openAddServiceDialog = true
                                                }

                                                is SelectServiceNavigation.EditService -> {
                                                    serviceToEdit = it.service
                                                    enableServiceEditByDefault = it.enableEdit
                                                    openAddServiceDialog = true
                                                }

                                                is SelectServiceNavigation.ClickService -> {}
                                            }
                                        },
                                        dragAndDropState = dragAndDropState,
                                        isDragEnabled = addEditProposalState.isEnabled &&
                                            !addEditProposalState.isLoading &&
                                            !addEditProposalState.addEditProposal.isLoading,
                                        onArrowClick = { sidePanelState.sidePanelOpened = false },
                                        modifier = Modifier.fillMaxHeight(),
                                    )
                                }
                            },
                            splitter = Splitter(
                                measuredPart = {
                                    Box(
                                        modifier = Modifier
                                            .width(1.spacing)
                                            .height(availableHeight)
                                            .graphicsLayer {
                                                translationY = sidePanelYOffset
                                            },
                                    )
                                },
                            ),
                            modifier = Modifier,
                        ) {
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth(),
                            ) {
                                Column(
                                    modifier = Modifier.fillMaxWidth(),
                                ) {
                                    journeyDays(
                                        dragAndDropState = dragAndDropState,
                                        isDateValid = addEditProposalScreenModel.validation.addEditProposalForm.dateRange.state.isValid,
                                        numberOfDays = numberOfDays ?: -1,
                                        filteredProposalServices = filteredProposalServices,
                                        state = addEditProposalState,
                                        onEvent = addEditProposalScreenModel::onEvent,
                                        onNavigation = { it.navigate() },
                                    )
                                }

                                if (!sidePanelState.sidePanelOpened) {
                                    Spacer(modifier = Modifier.width(1.spacing))

                                    Box(
                                        modifier = Modifier
                                            .height(availableHeight)
                                            .align(Alignment.TopEnd)
                                            .graphicsLayer {
                                                translationY = sidePanelYOffset
                                            }
                                            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                                            .background(MaterialTheme.esColorScheme.bgSecondary)
                                            .padding(2.5f.spacing),
                                    ) {
                                        EsMediumOutlineIconButton(
                                            iconRes = EsIcons.ArrowLeft,
                                            enabled = addEditProposalState.isEnabled,
                                            onClick = {
                                                sidePanelState.sidePanelOpened = true
                                            },
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        AddEditServicePopup(
            state = addEditServiceState,
            validation = addEditServiceScreenModel.validation,
            onEvent = addEditServiceScreenModel::onEvent,
            contactState = contactState,
            contactEvent = contactScreenModel::onEvent,
            service = serviceToEdit,
            openDialog = openAddServiceDialog,
            enableEdit = enableServiceEditByDefault,
            onDismissRequest = {
                openAddServiceDialog = false
                serviceToEdit = null
            },
        )

        AddEditClientDialog(
            openDialog = openAddEditClientDialog,
            currentClient = clientToEdit,
            state = addEditClientState,
            validation = addEditClientScreenModel.validation,
            onEvent = addEditClientScreenModel::onEvent,
            onDismissRequest = {
                openAddEditClientDialog = false
                clientToEdit = null
            },
        )

        SelectClientDialog(
            isOpen = isSelectClientDialogOpen,
            onDismissRequest = {
                isSelectClientDialogOpen = false
            },
            getAllClients = allClientState.getAllClients,
            onLoadMoreClient = {
                allClientScreenModel.onEvent(AllClientsEvent.LoadClients())
            },
            onSearchTextChange = {
                allClientScreenModel.onEvent(AllClientsEvent.SearchClient(it))
            },
            onSelectClient = { client ->
                isSelectClientDialogOpen = false
                addEditProposalScreenModel.onEvent(AddEditProposalEvent.AddClient(client))
            },
        )

        SetDynamicPriceDialog(
            isOpen = openSetPriceDialog,
            isDynamicPrice = FeatureConfig.hasDynamicPricing,
            currentRole = addEditProposalState.getProfile.data?.role,
            onDismissRequest = {
                openSetPriceDialog = false
                proposalService = null
            },
            currentProposalService = proposalService ?: ProposalServiceModel.empty,
            onSave = { ps, prices ->
                if (addEditProposalScreenModel.validation.addEditProposalForm.validate()) {

                    addEditProposalScreenModel.onEvent(AddEditProposalEvent.UpdateProposalService(ps))

                    addEditProposalScreenModel.onEvent(AddEditProposalEvent.EditProposal(context))

                    if (prices.isNotEmpty())
                        addEditProposalScreenModel.onEvent(
                            AddEditProposalEvent.UpdateProposalServicePrices(prices),
                        )

                    openSetPriceDialog = false
                    proposalService = null
                }
            },
        )

        AddEditTaskPopup(
            taskId = editTaskId,
            openDialog = editTaskId != null || addTaskProposalId != null,
            onDismissRequest = {
                editTaskId = null
                addTaskProposalId = null

                addEditTaskScreenModel.onEvent(AddEditTaskEvent.ClearTaskState)
            },
            state = addEditTaskState,
            onEvent = addEditTaskScreenModel::onEvent,
            validation = addEditTaskScreenModel.validation,
        )

        ContactOrganizationDialog(
            isOpen = openAddEditTravelAgentDialog,
            onDismissRequest = { openAddEditTravelAgentDialog = false },
            type = OrganizationModel.Type.TravelAgency,
            state = contactOrganizationState,
            onEvent = contactOrganizationScreenModel::onEvent,
            organizationState = organizationState,
            onOrganizationEvent = organizationScreenModel::onEvent,
            organizationValidation = organizationScreenModel.validation,
            organizationAddressState = organizationAddressState,
            onOrganizationAddressEvent = organizationAddressScreenModel::onEvent,
            organizationAddressValidation = organizationAddressScreenModel.validation,
            contactState = contactState,
            onContactEvent = contactScreenModel::onEvent,
            contactValidation = contactScreenModel.validation,
            contactAddressState = contactAddressState,
            onContactAddressEvent = contactAddressScreenModel::onEvent,
            contactAddressValidation = contactAddressScreenModel.validation,
            customFieldsState = customFieldsState,
            onCustomFieldsEvent = customFieldsScreenModel::onEvent,
        )
    }

    @Composable
    private fun AddEditProposalSidePanelContent(
        state: SelectServiceState,
        onEvent: (SelectServiceEvent) -> Unit,
        onNavigation: (SelectServiceNavigation) -> Unit,
        dragAndDropState: DragAndDropState<Pair<ServiceModel, ProposalServiceModel>>,
        isDragEnabled: Boolean,
        allSupplierState: AllSuppliersState,
        onEventAllSupplier: (AllSuppliersEvent) -> Unit,
        isEnabled: Boolean = true,
        onArrowClick: () -> Unit,
        modifier: Modifier = Modifier,
    ) {
        LaunchedEffect(Unit) {
            onEvent(SelectServiceEvent.GetAllService)
        }

        if (state.selectedProposalService.value != null)
            state.selectedProposalService.value?.let { proposalService ->
                ProposalServiceInfos(
                    proposalService = proposalService,
                    service = proposalService.service,
                    getAllSupplier = state.getAllSupplier,
                    isLoading = false,
                    isEnabled = isEnabled,
                    onNavigation = onNavigation,
                    showArrow = true,
                    onArrowClick = onArrowClick,
                    onProposalServiceChanged = {
                        onEvent(SelectServiceEvent.ProposalServiceChanged(it))
                    },
                )
            }
        else
            ServiceColumn(
                state = state,
                onEvent = onEvent,
                onNavigation = onNavigation,
                allSupplierState = allSupplierState,
                onEventAllSupplier = onEventAllSupplier,
                dragAndDropState = dragAndDropState,
                isDragEnabled = isDragEnabled,
                showArrow = true,
                onArrowClick = onArrowClick,
                modifier = modifier,
            )
    }
}